<template>
	<div class="apply">
		<!-- 顶部导航 -->
		<div class="nav">
			<van-icon name="arrow-left" color="#fff" size="1.2rem" @click="back" />
			<span>系统消息</span>
			<div></div>
		</div>
		<!-- 申请售后 -->
		<!-- 		<div>
			<div class="xiaoxizhong" style="padding-top: 3rem;">
				2020-08-01 12:20
			</div>
			<div class="shouho-coder">
				<div class="shouhou-heder">
					<div><img src="../../../assets/tupian/圆角矩形 1911.png" alt=""></div>
					<div> <span>网络安全检查工作</span></div>
				</div>
				<div class="shouhou-erer">
					<div>&nbsp;&nbsp;&nbsp;&nbsp;为全面提升本市电信和互联网行业的网络安全防护水平，根据《关于开展2020年全市网络安全专项检查的通知》等文件要求，结合我局职责，决定组织开展2020年电信和互联网行业网络安全检查工作。</div>
				</div>
			</div>
		</div> -->
		<div v-if="xiaoxiList.length == 0" class="tips">没有更多了~</div>
		<div v-for="(item,index) in xiaoxiList" :key="index">
			<div class="xiaoxizhong" style="padding-top: 2rem;">
				{{item.create_time}}
			</div>
			<div class="shouho-coder">
				<div class="shouhou-heder">
					<div><img src="../../../assets//tupian/圆角矩形 23.png" alt=""></div>
					<div> <span>{{item.title}}</span></div>
				</div>
				<div class="shouhou-erer">
					<div class="shouhou-erers" style="text-indent:30px;" v-html="item.content"></div>
				</div>
			</div>
		</div>
		<div style="height: 25px; width: 100%;"></div>

	</div>
</template>
<script>
	export default {
		data() {
			return {
				xiaoxiList: "",
			}
		},
		created() {
			this.$axios.post(baseUrl + "/mobile/Base/siteMsg", {
				token: localStorage.getItem('Authorization')
			}).then(res => {
				this.xiaoxiList = res.data.data.data
			})
		}
	}
</script>
<style scoped>
	.tips {
		color: #B2B2B2;
		text-align: center;
		font-size: 0.8rem;
		margin-top: 5rem;
	}

	.xiaoxizhong {
		padding-bottom: 0.8rem;
		padding-top: 1.6rem;
		color: #969799;
		text-align: center;
	}


	.shouho-coder {
		text-align: left;
		margin: 0 1.5rem;
		background: #ffffff;
		border-radius: 5px;
		padding: 1rem 0;
	}

	.shouhou-heder {
		display: flex;
		border-bottom: 1px solid #dde5ed;
		line-height: 1.5rem;
		height: 2.8rem;
	}

	.shouhou-heder img {
		height: 1.2rem;
		width: 1.2rem;

	}

	.shouhou-heder :nth-child(2) {
		margin-left: 0.3rem;
	}

	.shouhou-heder :nth-child(1) {
		margin-left: 0.3rem;
		margin-top: 0.35rem;
	}

	.shouhou-heder div:nth-child(2)>span {
		position: relative;
		top: 0.6rem;
		font-size: 0.9rem;
	}

	.shouhou-erer {
		font-size: 0.8rem;
		color: #969799;
		line-height: 1.8rem;
		margin-top: 10px;
	}

	.shouhou-erers >>> img {
		width: 99%;
		display: block;
		margin: auto;
	}

	.xiasxizhong {
		text-align: center;
		padding-top: 0.5rem;
		padding-bottom: 0.5rem;
		color: #969799;
	}

	.shouhou-erer div {
		padding: 0.4rem 0.8rem;
	}

	.shouhou-ererer div {
		padding: 0.4rem 0.8rem;
	}
</style>



// WEBPACK FOOTER //
// src/components/min/xiaoxizhongxin/xiaoxi.vue